@import '../../../../../../constants/spacing.module.less';
@import '../../../../../../constants/screen-width-breakpoints.module.less';
@import '~style-sheet-helpers/core.less';

.returns-step {
  max-width: 870px;
  margin: auto;
  padding: @space-0 @space-24;
  text-align: left;

  @media @mobile, @ultramobile {
    padding: @space-0 @space-12;
  }
}

.returns-step-title {
  font-weight: 700;
  text-align: left;
  margin-bottom: 4px;
}
.activate-title {
  text-align: left;
  margin-bottom: 4px;
}

.returns-step-description {
  color: var(--gray-637381);
}

.returns-step-advanced-scenario,
.returns-step-configuration-scenario {
  border: 1px solid var(--gray-DFE4E8);
  border-radius: 8px;
  background-color: var(--white);
  padding: @space-16;
  margin-top: 8px;
}

.returns-step-store-card {
  align-items: center;
  justify-content: space-between;
  padding: @space-16;
  border: 1px solid var(--gray-E4E5E7);
  border-radius: 8px;
  background-color: var(--white);
  margin-top: @space-24;
}

.returns-step-store-info {
  display: flex;
  align-items: center;
  gap: @space-12;
}

.returns-step-store-icon {
  width: 24px;
  height: 24px;
  display: block;

  svg {
    width: 100%;
    height: 100%;
  }
}

.returns-step-activate-button {
  background-color: var(--green-0D6E3F);
  color: var(--white);
  padding: @space-8 @space-16;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
}

.returns-step-activate-button:hover {
  background-color: var(--green-0D6E3F);
}

.returns-step-radio-options {
  display: flex;
  flex-direction: column;
  gap: @space-12;
  margin-top: @space-24;

  // Style the RadioCheckListItem components to match the original design
  > div {
    padding: @space-16;
    border: 1px solid var(--gray-E4E5E7);
    border-radius: 8px;
    background-color: var(--white);
    cursor: pointer;
    transition: border-color 0.2s ease;

    &:hover {
      border-color: var(--blue-256FEB);
    }
  }
}

.returns-step-banner {
  margin-top: @space-16;
  text-align: left;
}

.returns-step-service-selection {
  text-align: left;
  border-radius: 8px;
  border: 1px solid var(--gray-DFE4E8);
  background-color: var(--white);
  padding: @space-16;
}

.returns-step-service-title {
  margin-bottom: @space-8;
}

.returns-step-service-description {
  margin-bottom: @space-16;
  font-size: 14px;
  color: var(--gray-637381);
}

.returns-step-dropdowns {
  display: grid;
  grid-template: 'carrier service' auto 'package .' auto / 1fr 1fr;
  gap: @space-16;

  @media @mobile, @ultramobile {
    grid-template: 'carrier' auto 'service' auto 'package' auto / 1fr;
  }
}

.returns-step-dropdowns-stacked {
  display: flex;
  flex-direction: column;
  gap: @space-16;
}

.returns-step-dropdown-group {
  min-width: 200px;

  &:nth-child(1) {
    grid-area: carrier;
  }

  &:nth-child(2) {
    grid-area: service;
  }

  &:nth-child(3) {
    grid-area: package;
  }
}

.returns-step-dropdown-label {
  font-size: 14px;
  font-weight: 500;
  color: var(--gray-333333);
}

.returns-step-dropdown {
  width: 100%;
}

.returns-step-controls {
  display: flex;
  flex-direction: column;
  gap: @space-16;
  margin-top: @space-16;
  align-items: flex-start;
}

.returns-step-connected-view {
  text-align: left;
  background-color: var(--white);
  border: 1px solid var(--gray-DFE4E8);
  border-radius: 8px;
  padding: @space-16;
  margin-top: @space-24;
}

.returns-step-activated-store-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: @space-16;
}

.returns-step-activated-badge {
  background-color: var(--green-EDFDF5);
  color: var(--gray-0F0F10);
  border: 1px solid var(--green-B6F6D7);
  padding: @space-4 @space-8;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  margin-left: @space-8;
}

.returns-step-manage-link {
  color: var(--blue-256FEB);
  text-decoration: none;
  font-weight: 500;

  &:hover {
    text-decoration: underline;
  }
}

.returns-step-settings-section {
  margin-top: @space-32;
}

.returns-step-section-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: @space-8;
  color: var(--gray-333333);
}

.returns-step-settings-grid {
  display: flex;
  flex-direction: column;
  gap: @space-12;
}

.returns-step-setting-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: @space-4 0;
}

.returns-step-setting-label {
  font-weight: 500;
  color: var(--gray-637381);
}

.returns-step-setting-value {
  color: var(--gray-333333);
  text-align: right;
}

.returns-step-portal-section {
  margin-top: @space-16;
}

.returns-step-portal-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.returns-step-portal-label {
  font-weight: 500;
  color: var(--gray-637381);
}

.returns-step-configure-link {
  color: var(--blue-256FEB);
  text-decoration: none;
  font-weight: 500;

  &:hover {
    text-decoration: underline;
  }
}

.returns-step-configure-icon,
.right-arrow-icon {
  margin-left: @space-4;
  color: var(--blue-256FEB);
  width: 12px;
  height: 12px;
}

.returns-step-portal-url {
  display: flex;
  align-items: center;
  gap: @space-8;
}

.returns-step-portal-url-text {
  color: var(--gray-333333);
}

.returns-step-copy-icon {
  cursor: pointer;
  width: 16px;
  height: 16px;
  display: flex;
  margin-left: @space-8;
}

.returns-step-advanced-options {
  margin-top: @space-32;
}

.returns-step-stores-section {
  margin-top: @space-16;
}

.returns-step-store-section {
  margin-bottom: @space-16;

  &:last-child {
    margin-bottom: 0;
  }
}

.returns-step-no-returns-section {
  margin-top: @space-24;
  border: 1px solid var(--gray-E4E5E7);
  border-radius: 8px;
  overflow: hidden;

  @media @mobile, @ultramobile {
    flex-direction: column-reverse;
  }
}

.returns-step-no-returns-text {
  flex: 1;
  text-align: left;
  padding: @space-24;
  background-color: var(--white);
  justify-content: space-between;
}

.returns-step-no-returns-title {
  font-size: 18px;
  font-weight: 600;
  color: var(--gray-333333);
  margin-bottom: @space-8;
}

.returns-step-no-returns-description {
  font-size: 14px;
  color: var(--gray-637381);
  line-height: 1.5;
}

.returns-step-no-returns-illustration {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--green-E5F6EE);
  padding: @space-16 @space-0;
}

.returns-step-illustration-placeholder {
  width: 100%;
  height: 100%;
  background-color: var(--green-D8FFEB);
  border: 2px dashed var(--green-05B45E);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--green-0D6E3F);
  font-size: 12px;
  font-weight: 500;
  text-align: center;
}

.returns-help-link {
  font-weight: 500;
}

// New styles for return settings card container
.return-settings-card {
  padding: @space-16;
  border: 1px solid var(--gray-DFE4E8);
  border-radius: 8px;
  background-color: var(--gray-F7F8FA);
  margin-top: @space-16;
}

// New styles for return settings display
.return-settings-display {
  padding: @space-16;
  border: 1px solid var(--gray-DFE4E8);
  border-radius: 8px;
  background-color: var(--white);
  margin-top: @space-24;
}

.return-settings-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: @space-16;
}

.edit-button {
  color: var(--blue-256FEB);

  &:hover {
    color: var(--blue-256FEB);
    text-decoration: underline;
  }
}

.edit-button-content {
  display: flex;
  align-items: center;
  gap: @space-4;
}

.return-settings-content {
  display: flex;
  flex-direction: column;
  gap: @space-12;
}

.setting-row {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}

.button-group {
  display: flex;
  gap: @space-8;
}

.save-button-content {
  display: flex;
  align-items: center;
  gap: @space-4;
}

.error-message {
  margin-bottom: @space-16;
  padding: @space-8;
  background-color: var(--red-FFF5F5);
  border: 1px solid var(--red-FEB2B2);
  border-radius: 4px;
  color: var(--red-C53030);
}

.error-text {
  color: var(--red-C53030);
}

.spinning {
  animation: spin 1s linear infinite;
}

.icon {
  width: 12px;
  height: 12px;
  margin-right: 4px;
}

.returns-setup {
  margin-top: @space-36;
}

.connect-store-banner {
  border-radius: 4px;
  margin-bottom: @space-16;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.other-stores {
  margin: @space-32 0 @space-16 0;
}

.other-stores-no-marketplace {
  margin: @space-16 0 @space-16 0;
}

.info-icon {
  margin-left: @space-4;
}

.returns-step-portal-label-with-icon {
  align-items: center;
  gap: @space-4;
}

.returns-step-portal-info-icon {
  width: 16px;
  height: 16px;
  color: var(--gray-637381);
  display: flex;
  align-items: center;
}

.returns-step-portal-divider {
  height: 1px;
  background-color: var(--gray-E4E5E7);
  border: none;
}
.ship-from-link {
  display: inline;
}

.returns-initiation-options {
  margin-top: @space-36;
}

.returns-initiation-checkboxes {
  margin-top: @space-24;
}

.returns-initiation-checkbox-item {
  padding: @space-16;
  border: 1px solid var(--gray-E4E5E7);
  border-radius: 8px;
  background-color: var(--white);
  transition: border-color 0.2s ease;

  &[data-checked='true'] {
    border-color: var(--blue-256FEB);
    background-color: var(--white);
  }
}

.returns-initiation-checkbox-content {
  padding-top: @space-12;
  padding-left: @space-24;
}

.returns-initiation-description {
  color: var(--gray-637381);
  font-size: 14px;
  margin-bottom: @space-16;
}

.returns-initiation-learn-more-link {
  color: var(--blue-256FEB);
  font-weight: 500;
  margin-left: @space-4;
}

.returns-initiation-banner {
  border-radius: 4px;
}

.returns-initiation-banner-text {
  font-size: 13px;
}

.returns-step-store-toggle-row {
  padding: @space-16 @space-0;
  border-bottom: 1px solid var(--gray-E4E5E7);

  &:last-child {
    border-bottom: none;
  }
}

.returns-step-store-expanded {
  margin-top: @space-12;
}

.returns-step-portal-url-box {
  background-color: var(--gray-F7F8FA);
  border-radius: 4px;
  padding: @space-8 @space-12;
  align-items: center;
  justify-content: space-between;
  margin-top: @space-8;
}

.returns-step-portal-url-link {
  color: var(--blue-256FEB);
}

.returns-step-customize-portal-link {
  display: inline-flex;
  white-space: nowrap;
  flex-shrink: 0;
}

.returns-step-customize-portal-icon {
  width: 12px;
  height: 12px;
  color: var(--blue-256FEB);
}

.returns-step-marketplace-banner {
  margin-top: @space-8;
}
